// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__cUJpK","label__helper":"style_label__helper__1Vq4t"};